import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-automated-custom-form',
  templateUrl: './automated-custom-form.component.html',
  styleUrls: ['./automated-custom-form.component.scss']
})
export class AutomatedCustomFormComponent implements OnInit {

  @Input() index: number;
  @Input() data: any = [];
  @Output() closeEvent = new EventEmitter();
  public games: any = [];
  constructor(private http: HttpService) { }

  ngOnInit(): void {
    this.getGames();
  }

  async getGames() {
    const res = await this.http.post('/admin/setting/seemless-game/get/list');
    this.games = res;
    this.games.forEach(game => {
      let match = this.data.find(item => item.id == game.id);
      if(match) {
        game.commission = match.commission;
      }
    });
  }

  save() {
    let filterGames = this.games.filter(game => game.commission != null && game.commission !== '');
    console.log(filterGames);
    this.closeEvent.emit(filterGames);
  }
}
